import React, { memo } from 'react';
import IconWrapper from './IconWrapper';

const IconCart = (props) => (
  <IconWrapper fill={props.fill ? props.fill : "#3fbeac"} className={`cart ${props.className}`} viewBox="0 0 578.5 510.91">
    <style>{`.cls-1{stroke-linecap:round;}.cls-1,.cls-2{fill:none;stroke:${props.fill ? props.fill : "#3fbeac"};stroke-linejoin:round;stroke-width:38.72px;}`}</style>
    <path className="cls-1"
          d="m19.36,19.36h67.02c16.22,0,30.32,11.14,34.08,26.92l77.87,326.8c4.38,18.38,20.8,31.35,39.7,31.35h236.28" />
    <polygon className="cls-2" points="505.62 326.61 187.24 326.61 133.72 101.99 559.14 101.99 505.62 326.61" />
    <line className="cls-2" x1="532.38" y1="214.3" x2="160.48" y2="214.3" />
    <g>
      <line className="cls-2" x1="559.14" y1="101.99" x2="505.62" y2="326.61" />
      <line className="cls-2" x1="417.33" y1="101.99" x2="399.49" y2="326.61" />
      <line className="cls-2" x1="275.53" y1="101.99" x2="293.37" y2="326.61" />
    </g>
    <circle className="cls-1" cx="474.3" cy="447.99" r="43.56" />
    <circle className="cls-1" cx="216.3" cy="447.99" r="43.56" />
  </IconWrapper>
)

export default memo(IconCart);